@if(isLoadingGraph) {
    <app-loading-indicator />
    } 
    
@if (showAddAnnotation()) {
    <div class="supervisor-dialog-backdrop"></div>
    <dialog class="supervisor-dialog" open>
    <app-add-annotation
        [patientID]="patientIDAsNumber"
        [annotationToEdit]="annotationToEdit()"
        (close)="onCloseAddAnnotation($event)"
    />
    </dialog>
}

<div class="card mx-5">
    <div class="card-header">
      <div class="row">
        <!-- Graph Options -->
        <div class="col-12 col-lg-6">
          <label for="selectTarget" style="font-weight: bold; color: #719eb6">Graph Options:</label>

        <!-- Date Options -->
        <div class="control-row">
            <div class="control no-margin">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
                >Date Options:</label
            >
            <p-dropdown
                [options]="dateOptions"
                [(ngModel)]="dateOption"
                appendTo="body"
                styleClass="w-100"
                optionValue="value"
                optionLabel="label"
                [showClear]="true"
                [disabled]="isLoadingGraph"
                [loading]="isLoadingGraph"
                (onChange)="onDateOptionChange($event)"
            />
            </div>
        </div>
        
        <!-- Date Picker -->
        <div class="control-row">
            <div class="d-flex justify-content-between mt-2">
              <div>
                <label for="startDatePicker" style="font-weight: bold; color: #719eb6; margin-right: 0.5rem;"
                  >Start Date:</label
                >
                <input
                  pInputText
                  type="date"
                  [ngModel]="formatDateForInput(startDate())"
                  (ngModelChange)="onStartDateChange($event)"
                  id="startDatePicker"
                  [max]="formatDateForInput(endDate())"
                />
              </div>
              <div>
                <label for="endDatePicker" style="font-weight: bold; color: #719eb6; margin-right: 0.5rem;"
                  >End Date:</label
                >
                <input
                  pInputText
                  type="date"
                  [ngModel]="formatDateForInput(endDate())"
                  (ngModelChange)="onEndDateChange($event)"
                  id="endDatePicker"
                  [min]="formatDateForInput(startDate())"
                />
              </div>
            </div>
            <div class="mt-2">
              <p-checkbox
                [(ngModel)]="forceGraphPeriod"
                (ngModelChange)="onForceGraphPeriodChange($event)"
                [binary]="true"
                inputId="forceGraphPeriod"
                [disabled]="isLoadingGraph"
              ></p-checkbox>
              <label for="forceGraphPeriod" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem; cursor: pointer;">
                Force graph period to selected start/end dates
              </label>
            </div>
        </div>

        <!-- Grouping Options -->
        <div class="control-row">
            <div class="control no-margin">
              <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
                >Grouping Options:</label
              >
              <p-dropdown
                [options]="groupingOptions"
                [(ngModel)]="groupingOption"
                appendTo="body"
                styleClass="w-100"
                optionValue="value"
                optionLabel="text"
                [disabled]="isLoadingGraph"
                [loading]="isLoadingGraph"
                (onChange)="onGroupingOptionChange($event)"
              />
            </div>
        </div>

        <!-- Staff Member Options -->
        <div class="control-row">
            <div class="control no-margin">
              <label for="selectedGraphType" style="font-weight: bold; color: #719eb6"
                >Staff Member:</label
              >
              <p-dropdown
                [options]="staffMembers()"
                [(ngModel)]="selectedStaffMember"
                appendTo="body"
                styleClass="w-100"
                optionLabel="FullName"
                (onChange)="onStaffMemberChange($event)"
                [disabled]="isLoadingGraph"
                [showClear]="true"
                [loading]="isLoadingGraph"
                placeholder="Select a Staff Member to filter by or leave empty to include all staff members"
              />
            </div>
        </div>

        <!-- Display Options -->
        <div class="control-row">
            <label for="selectedGraphType" style="font-weight: bold; color: #719eb6">Display Options:</label>
            <div class="col-12">
            <div class="d-flex align-items-center justify-content-start">
                <div class="control me-4">
                    <label for="seriesDataLabelOption" style="font-weight: bold; color: #719eb6">Series:</label>
                    <p-dropdown
                    [options]="seriesDataLabelOptions"
                    [(ngModel)]="seriesDataLabelOption"
                    appendTo="body"
                    styleClass="w-100"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onSeriesDataLabelOptionChange()"
                    [disabled]="isLoadingGraph"
                    [loading]="isLoadingGraph"
                    placeholder="Select series display option"
                    />
                </div>

                <div class="d-flex flex-column me-4">
                    <div class="d-flex align-items-center">
                    <p-checkbox
                        class="ms-2"
                        [(ngModel)]="displayTrendLine"
                        (ngModelChange)="onToggleTrendLine()"
                        [binary]="true"
                        [style]="{'color': '#719eb6'}"
                        inputId="displayTrendLine"
                    />
                    <label for="displayTrendLine" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">Trend Line</label> 
                    </div>
                    @if(displayTrendLine()) {
                    <div class="control mt-2">
                        <label for="trendLineDataLabelOption" style="font-weight: bold; color: #719eb6">Trend Line:</label>
                        <p-dropdown
                        [options]="trendLineDataLabelOptions"
                        [(ngModel)]="trendLineDataLabelOption"
                        appendTo="body"
                        styleClass="w-100"
                        optionLabel="label"
                        optionValue="value"
                        [disabled]="isLoadingGraph"
                        [loading]="isLoadingGraph"
                        (onChange)="onTrendLineDataLabelOptionChange()"
                        placeholder="Select trend line display option"
                        />
                    </div>
                    <div class="d-flex align-items-center mt-2">
                        <p-checkbox
                        class="ms-2"
                        [(ngModel)]="segmentTrendLineByPhase"
                        (ngModelChange)="onToggleSegmentTrendLineByPhase()"
                        [binary]="true"
                        [style]="{'color': '#719eb6'}"
                        [disabled]="isLoadingGraph"
                        inputId="segmentTrendLineByPhase"
                        />
                        <label for="segmentTrendLineByPhase" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">By Phase Changes</label>
                    </div>
                    }
                </div>

                @if(hasAverageAnnotations()) {
                <div class="d-flex align-items-center me-4">
                    <p-checkbox
                    class="ms-2"
                    [ngModel]="displayAverage()"
                    (ngModelChange)="onToggleAverage($event)"
                    [binary]="true"
                    [style]="{'color': '#719eb6'}"
                    [disabled]="isLoadingGraph"
                    inputId="displayAverage"
                    />
                    <label for="displayAverage" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">Average</label>
                </div>
                }

                <div class="d-flex align-items-center me-4">
                    <p-checkbox
                    [(ngModel)]="isGrouped"
                    (ngModelChange)="onToggleGrouped()"
                    [binary]="true"
                    [style]="{ color: '#719eb6' }"
                    inputId="isGrouped"
                    [disabled]="displayMergedSeries()"
                    />
                    <label
                    for="isGrouped"
                    style="font-weight: bold; color: #719eb6; margin-left: 0.5rem"
                    [style.opacity]="displayMergedSeries() ? 0.5 : 1"
                    >Toggle Grouped/Synced Graph</label
                    >
                </div>

                @if(shouldDisplayMergedSeriesOption()) {
                <div class="d-flex align-items-center me-4">
                    <p-checkbox
                    [(ngModel)]="displayMergedSeries"
                    (ngModelChange)="onToggleMergedSeries()"
                    [binary]="true"
                    [style]="{ color: '#719eb6' }"
                    inputId="displayMergedSeries"
                    [disabled]="!isGrouped()"
                    />
                    <label
                    for="displayMergedSeries"
                    style="font-weight: bold; color: #719eb6; margin-left: 0.5rem"
                    [style.opacity]="!isGrouped() ? 0.5 : 1"
                    >Combined Merged (average all series into one)</label
                    >
                </div>
                }

            </div>
            </div>
        </div>
      </div>
      <!-- Annotation Options -->
      <div class="col-12 col-lg-6">
        <app-annotation-display-panel
          [annotations]="annotations()"
          [displayAnnotations]="displayAnnotations()"
          [displayAutomaticAnnotations]="displayAutomaticAnnotations()"
          [displayUserAnnotations]="displayUserAnnotations()"
          [canAddAnnotation]="shouldDisplayAddAnnotationButton()"
          [showAnnotationDisplayOptions]="true"
          [isLoadingGraph]="isLoadingGraph"
          [annotationLabelBackground]="annotationLabelBackgroundOption()"
          [annotationLabelBackgroundOptions]="annotationLabelBackgroundOptions"
          [declutterAnnotations]="declutterAnnotations()"
          [isAnnotationDisplayed]="isAnnotationDisplayedForPanel"
          (displayAnnotationsChange)="onDisplayAnnotationsChange($event)"
          (displayAutomaticAnnotationsChange)="onToggleAutomaticAnnotations($event)"
          (displayUserAnnotationsChange)="onToggleUserAnnotations($event)"
          (annotationDisplayChange)="onAnnotationDisplayChange($event.annotation, $event.isDisplayed)"
          (addAnnotation)="addAnnotationButtonClicked()"
          (editAnnotation)="editAnnotation($event)"
          (annotationLabelBackgroundChange)="onAnnotationLabelBackgroundOptionSelected($event)"
          (declutterAnnotationsChange)="onDeclutterAnnotationsSelected($event)"
          (labelPositionChange)="onAnnotationLabelPositionChange($event.annotation, $event.labelPosition)"
        />
    </div>
    </div>

  <div
    class="card-body"
    style="padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem"
  >
    <!-- Graph -->
    @if(shouldDisplayGraph()) {
      @if(this.isGrouped()) {
        <apx-chart
        #chart
        [series]="chartOptions.series || []"
        [chart]="chartOptions.chart || { type: 'line' }"
        [xaxis]="chartOptions.xaxis || {}"
        [yaxis]="chartOptions.yaxis || {}"
        [title]="chartOptions.title || {}"
        [dataLabels]="chartOptions.dataLabels || {}"
        [grid]="chartOptions.grid || {}"
        [stroke]="chartOptions.stroke || {}"
        [labels]="chartOptions.labels || []"
        [annotations]="chartOptions.annotations || {}"
        [legend]="chartOptions.legend || {}"
        [markers]="chartOptions.markers || {}"
        [tooltip]="chartOptions.tooltip || {}"
        [responsive]="chartOptions.responsive || []"
        [plotOptions]="chartOptions.plotOptions || {}"
        [colors]="chartOptions.colors || []"
      ></apx-chart>
        @if(shouldDisplayDeclutterLegend()) {
          <app-annotation-color-legend [items]="getDeclutterLegendItems(graphData())" />
        }
      } @else {
        @for(chartOptions of chartsOptions; track chartOptions.chart?.id) {
          <apx-chart
          [series]="chartOptions.series || []"
          [chart]="chartOptions.chart || { type: 'line' }"
          [xaxis]="chartOptions.xaxis || {}"
          [yaxis]="chartOptions.yaxis || {}"
          [title]="chartOptions.title || {}"
          [dataLabels]="chartOptions.dataLabels || {}"
          [grid]="chartOptions.grid || {}"
          [stroke]="chartOptions.stroke || {}"
          [labels]="chartOptions.labels || []"
          [annotations]="chartOptions.annotations || {}"
          [legend]="chartOptions.legend || {}"
          [markers]="chartOptions.markers || {}"
          [tooltip]="chartOptions.tooltip || {}"
          [responsive]="chartOptions.responsive || []"
          [plotOptions]="chartOptions.plotOptions || {}"
          [colors]="chartOptions.colors || []"
          ></apx-chart>
          @if(shouldDisplayDeclutterLegend()) {
            <app-annotation-color-legend [items]="getDeclutterLegendItemsForChart(graphData(), chartOptions)" />
          }
        }
      }
    } @else {
    <div class="no-data">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        No data available for the selected target(s)/behavior(s).
      </p>
    </div>
    }

    @if(shouldDisplayGraph() && shouldDisplayAnnotationList()) {
      <app-annotation-list [items]="getAnnotationListItems()" />
    }
  </div>
  </div>
</div>
